import { useQuery } from "react-query";
import { z } from "zod";

import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";

const IngredientReferenceFromProductPreviewSchema = z.object({
    name: z.string(),
    code: z.string().nullable(),
    scores: z.array(
        z.object({
            scoreId: z.number(),
            campaignId: z.number(),
            value: z.number().nullable(),
        }),
    ),
});

export type IngredientReferenceFromProductPreview = z.infer<typeof IngredientReferenceFromProductPreviewSchema>;

type Options = {
    productId: number | null;
    enabled?: boolean;
};

export const ingredientReferenceFromProductPreviewKey = "ingredientReferenceFromProductPreview" as const;

export const useIngredientReferenceFromProductPreview = ({ productId, enabled = true }: Options) => {
    const isEnabled = enabled && productId !== null && productId > 0;

    return useQuery({
        queryKey: [ingredientReferenceFromProductPreviewKey, productId],
        enabled: isEnabled,
        staleTime: 0,
        queryFn: async () => {
            const response = await loggedInApiCall.get(`/api/ingredient-reference-from-product/${productId}/preview`);

            return zodParseWithDetailedLog(response.data, IngredientReferenceFromProductPreviewSchema, {
                operation: "GET",
                endpoint: "/ingredient-reference-from-product/:productId/preview",
            });
        },
    });
};
